import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Currencies } from 'src/config/labels/currencies';
import { ShippingMethod } from 'src/config/labels/shippingMethod';
import { Convertor } from 'src/infrastructure/convertorHelpers/convertor';
import { Order } from 'src/models/DTO/V2/orders/Order';
import { OrderCollection } from 'src/models/DTO/V2/orders/OrderCollection';
import {
  LocalstorageserviceService
} from 'src/services/infrastructureServices/localstorageservice/localstorageservice.service';
import { ImagesService } from 'src/services/requestServices/images/images.service';
import { PartnersService } from 'src/services/requestServices/partners/partners.service';
import { ProductService } from 'src/services/requestServices/products/product.service';
import { UsersService } from 'src/services/requestServices/users/users.service';
import { CarrierService } from 'src/services/requestServices/V2/carrier/carrier.service';
import { DocumentsService } from 'src/services/requestServices/V2/documents/documents.service';
import { ImageService } from 'src/services/requestServices/V2/image/image.service';
import { InfoService } from 'src/services/requestServices/V2/info/info.service';
import { OrdersService } from 'src/services/requestServices/V2/orders/orders.service';
import { ShipmentService } from 'src/services/requestServices/V2/shipment/shipment.service';
import { LoggeduserinfoService } from 'src/services/stateServices/loggeduserinfoservice/loggeduserinfo.service';
import { UserinfostoreService } from 'src/services/stateServices/userinfoservice/userregistrationstateservice.service';
import { LoggedinfoService } from 'src/services/stateServices/V2/loggedinfo/loggedinfo.service';
import { BaseDashboardComponent } from '../base-dashboard/base-dashboard.component';
import { OrderStatus } from 'src/config/labels/orderStatus';
import { LoadingstateService } from 'src/services/stateServices/loading/loadingstate.service';
import { environment } from 'src/environments/environment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Core } from 'src/infrastructure/coreFunctionHelpers/coreFunctions';
import { OrderStatusColors } from 'src/config/labels/orderStatusColors';
import { Labels } from 'src/config/labels/labels';
import { ErrorTranslations } from 'src/config/labels/errorTranslations';
import { Successes } from 'src/config/labels/successes';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DispatchTypes } from 'src/config/labels/dispatchTypes';
import { Fees } from 'src/config/labels/fees';
import { OrderCancellationReasons, OtherOrderCancellationReason } from 'src/config/labels/cancelOrderReasons';
import { ShipmentStatus } from 'src/config/labels/shipmentStatus';


declare var bootstrap: any;

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class OrdersComponent extends BaseDashboardComponent implements OnInit, AfterViewInit {

  @ViewChild('changeSpeedyUsername') _modal: ElementRef;
  @ViewChild('cancelWindow') _cancelWindowmodal: ElementRef;
  @ViewChild('returnWindow') _returnWindow: ElementRef;
  @ViewChild('cancelReturnWindow') _cancelReturnWindow: ElementRef;
  @ViewChild(MatSort) sort: MatSort;

  public displayedColumnsForOrdersTable: string[];
  public ordersDataSource: OrderCollection = { data: [] };
  public numberPerPageValue = -1;
  public page = 0;
  public status = 'waiting';
  public selectedOrder: Order;
  expandedElement: Order | null;
  faSearch = faSearch;
  public isReturnedTab = false;
  public existOrderReturnWaitingState = false;
  public  amountRequestedInput = 0;
  public  formattedAmountRequestedInput = '0.00';
  public readonly cancellationReasons = OrderCancellationReasons;
  public cancellationReason = '';
  public cancellationComment = '';

  private _tab = 'waiting';
  private _filter = [];
  private _dateSort = '-created_at';
  private _intervalToRefreshRemainingTime = 60000;
  private readonly _fulfillmentDeadlineDays = 14;
  private _serverClockOffsetMs = 0;
  private _numberOfParcels = 1;
  private _pageNumber = 1;
  private _searchString = '';
  private _searchType = 'name.contains';
  private _initialNumberOfLoadedPages = 3;
  private _maxPage = 100;
  private _scrolling = false;
  private displayedColumnsForNewOrdersTable = ['ID', 'Date', 'Type', 'Client', 'Method', 'Delivery', 'Status', 'Sum', 'Confirm', 'Cancel'];
  private displayedColumnsForProcessingOrdersTable = ['ID', 'Date', 'Type', 'Client', 'Method', 'Delivery', 'Status',  'Sum', 'PickUp', 'Generate', 'Print', 'Cancel'];
  private displayedColumnsForCompletedOrdersTable = ['ID', 'Date', 'Type', 'Client', 'Method', 'Delivery', 'Status', 'Sum'];
  private displayedColumnsForCanceledOrdersTable = ['ID', 'Date', 'Type', 'Client', 'Method', 'Delivery', 'Sum', 'Status', 'Tax'];
  private displayedColumnsForReturnedOrdersTable = ['ID', 'RequestDate', 'Client', 'EndDate', 'Status', 'Sum', 'ReturnedSum', 'Return', 'CancelReturn'];
  private displayedColumnsForAllOrdersTable = ['ID', 'Date', 'Type', 'Client', 'Status', 'Price', 'Tax', 'ShareMe', 'Net'];
  private _currentOpenWindow?: NgbModalRef = null;
  private _orderFees = {
    return: 'ORDER_REFUND_TYPE_FEE',
    cancel: 'ORDER_CANCELATION_TYPE_FEE',
    shareMe: 'ORDER_DELIVERY_TYPE_FEE'
  };

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected userStateService: UserinfostoreService,
    protected localStorageService: LocalstorageserviceService,
    protected loggeduserinfoservice: LoggeduserinfoService,
    protected partnersService: PartnersService,
    protected productService: ProductService,
    protected usersService: UsersService,
    protected router: Router,
    protected imagesService: ImagesService,
    protected sanitizer: DomSanitizer,
    protected loggedInfoService: LoggedinfoService,
    protected infoService: InfoService,
    private ordersService: OrdersService,
    protected imageService: ImageService,
    private loadingState: LoadingstateService,
    protected carrierService: CarrierService,
    protected documentsService: DocumentsService,
    private toatsrService: ToastrService,
    private shipmentService: ShipmentService,
    private modalService: NgbModal
  ) {
    super(activatedRoute, userStateService, localStorageService, usersService, loggeduserinfoservice,
      partnersService, imagesService, sanitizer, router, loggedInfoService, infoService, imageService, carrierService, documentsService);
    this.pageName = 'orders';
    const initialSelection = [];
    const allowMultiSelect = true;

    this.loadingState.loading$.subscribe(result => {
      this.isLoading = result;
    });

    this.displayedColumnsForOrdersTable = this.displayedColumnsForNewOrdersTable;

  }

  async ngOnInit(): Promise<void> {
    this.getUrlParams().subscribe(async (params) => {
      const defaultpage = params?.params?.defaultpage;
      if (defaultpage) {
        this.page = +defaultpage;
      }
      this.numberPerPageValue = Number.parseInt(this.localStorageService.getLocalStorageItem(Labels.ordersPerPage), 10) || 10;
      this._tab = this.localStorageService.getLocalStorageItem(environment.lsOrderTab) || 'waiting';
      this.changeStateFilter(this._tab);
      await this.loadData();
      this.refreshWaitingReturnIndicator();
    });
  }

  ngAfterViewInit(): void {
    setInterval(() => {
      this.recalculateRemainingTime();
    }, this._intervalToRefreshRemainingTime);

  }

  set numberOfParcels(numberOfParcels: number) {
    if (numberOfParcels < 1) {
      this._numberOfParcels = 1;
    }
    else if (numberOfParcels > 10) {
      this._numberOfParcels = 10;
    }
    else {
      this._numberOfParcels = numberOfParcels;
    }
  }

  set filter(filter: any[]) {
    this._filter = filter;
  }

  get columnNumberName(): string {
    if (this._tab === 'returned') {
      return 'Заявка №';
    }
    return this.dashboardLables(this.getPageName()).id;
  }

  get organisation(): any {
    return this.loggedPartner.data.organisations[0];
  }

  get tableDataSource(): MatTableDataSource<Order> {
    const tableDatasource = new MatTableDataSource(this.ordersDataSource.data);
    tableDatasource.sort = this.sort;
    return tableDatasource;
  }

  get currentPageLength(): string {
    const pageLength = this.page.toString().length;
    const width = 20 + pageLength * 10;
    return width.toString();
  }

  get lastPage(): number {
    return this._maxPage;
  }

  // V2
  // tslint:disable-next-line:adjacent-overload-signatures
  get numberOfParcels(): number {
    return this._numberOfParcels;
  }

  get numberPerPage(): string {
    return this.numberPerPageValue + ' ' + this.dashboardLables(this.getPageName()).productsLabel;
  }

  get hiddenPlaceholder(): string {
    return environment.hiddenValuesReplacement;
  }

  get hiddenBigPlaceholder(): string {
    return environment.hiddenValuesBigReplacement;
  }

  get pageNumber(): number{
    return +this._pageNumber;
  }

  get priceConvertor(): any {
    return Convertor.convertPrice.splitPriceToFloat;
  }

  get searchString(): string {
    return this._searchString;
  }

  get isLoggedPartener(): number {
    return Object.keys(this.loggedPartner).length;
  }

  get cancelRequestText(): string {
    return 'Ще бъде начислена такса отказване на поръчка 9.17% (без ДДС) от сумата на поръчката, ако я откажете.';
  }

  get isOtherCancellationReason(): boolean {
    return this.cancellationReason === OtherOrderCancellationReason;
  }

  get canCancelOrder(): boolean {
    return this.cancellationReason.length > 0
      && (!this.isOtherCancellationReason || this.cancellationComment.trim().length > 0);
  }

  get returnWindowTitle(): string {
    if (this.selectedOrder.paymentMethod.code === 'card') {
      return 'Възстановяване на сума';
    }
    return 'Въведете сумата, която сте възстановили';
  }

  get returnWindowText(): string {
    if (this.selectedOrder.paymentMethod.code === 'card') {
      return 'Сумата ще бъде възстановена от ShareMe и ще бъде удържана от следващото изплащане';
    }
    return 'При поръчка платена с наложен платеж, следва да възстановите сумата по посочената от клиента банкова сметка.';
  }

  get returnPriceText(): string {
    if (this.selectedOrder.paymentMethod.code === 'card') {
      return 'Сума за възстановяване:';
    }
    return 'Възстановена сума:';
  }

  get returnButtonTitle(): string {
    if (this.selectedOrder.paymentMethod.code === 'card') {
      return 'Възстанови';
    }
    return 'Въведи';
  }

  private async loadData(): Promise<void> {
    await this.onDirectNavigation();
  }

  private refreshWaitingReturnIndicator(): void {
    this.ordersService.search(
      1,
      1,
      'delivered',
      '',
      '-return_created_at',
      [{ filter: 'orderReturn.state', value: 'waiting' }]
    ).subscribe(orders => {
      this.existOrderReturnWaitingState = orders.data.length > 0;
    });
  }

  private getOrders(): void {
    if (this._searchString) {
      this.loadSearchedOrdersForTable();
    }
    else {
      this.loadOrdersForPartner();
    }
  }

  private initialLoad(): void {
    this.ordersDataSource = { data: []};
    // this.page = 1;
    this.getOrders();
  }

  private loadImagesForOrdersCollection(orders: OrderCollection): void {
    orders.data.forEach(order => {
      order.lines.forEach(line => {
        if (line.sku) {
          this.imageService.getImagesPerProduct('SKU', line.sku.uuid).subscribe(images => {
            line.imageSource = images.data[0]?.original.url;
          });
        }
      });
    });
  }

  private fixPaymentValues(orders: OrderCollection): OrderCollection {
    orders.data.forEach(order => {
      order.amount_captured = Number.parseFloat(Convertor.convertNumbers.addToFixedSuffix(order.amount_captured, 2));
      order.amount_refunded = Number.parseFloat(Convertor.convertNumbers.addToFixedSuffix(order.amount_refunded, 2));
      order.amount_reserved = Number.parseFloat(Convertor.convertNumbers.addToFixedSuffix(order.amount_reserved, 2));
      order.total_gross = Number.parseFloat(Convertor.convertNumbers.addToFixedSuffix(order.total_gross, 2));
      order.total_net = Number.parseFloat(Convertor.convertNumbers.addToFixedSuffix(order.total_net, 2));
      order.total_tax_amount = Number.parseFloat(Convertor.convertNumbers.addToFixedSuffix(order.total_tax_amount, 2));
      order.voucher_amount = Number.parseFloat(Convertor.convertNumbers.addToFixedSuffix(order.voucher_amount, 2));
      order.shipment_cost = Number.parseFloat(Convertor.convertNumbers.addToFixedSuffix(order.shipment_cost, 2));
      order.lines[0].single_gross = Number.parseFloat(Convertor.convertNumbers.addToFixedSuffix(order.lines[0].single_gross , 2));
      order.lines[0].single_net = Number.parseFloat(Convertor.convertNumbers.addToFixedSuffix(order.lines[0].single_net, 2));
      order.lines[0].single_tax_amount = Number.parseFloat(Convertor.convertNumbers.addToFixedSuffix(order.lines[0].single_tax_amount, 2));
    });
    return orders;
  }

  private hideTelephones(orders: OrderCollection): OrderCollection {
    orders.data.forEach(order => {
      if (order.invoice_address?.mobile_phone_1_e164) {
        order.invoice_address.mobile_phone_1_e164 = Core.replaceLastCharactersOfString(order.delivery_address.mobile_phone_1_e164, '*', 4);
      }
      if (order.delivery_address?.mobile_phone_1_e164) {
        order.delivery_address.mobile_phone_1_e164 = Core.replaceLastCharactersOfString(order.delivery_address.mobile_phone_1_e164, '*', 4);
      }
    });
    return orders;
  }


  private isPrinted(order: Order): boolean {
    return order.shipment?.length && order.shipment[0].is_printed;
  }

  private isRequested(order: Order): boolean {
    return !!(order.shipment?.length && order.shipment[0].state === 'request_pickup');
  }

  private isReturned(order: Order): boolean {
     return !!order.orderReturn;
  }

  private recalculateRemainingTime(): void {
    if (this.ordersDataSource.data.length) {
      this.ordersDataSource.data.forEach(order => this.attachRemainingDate(order));
    }
  }

  private compareTwoDates(dateStart: Date, dateEnd: Date): {days: number, hours: number} {
    // get total seconds between the times
    let delta = Math.abs(dateEnd.getTime() - dateStart.getTime()) / 1000;

    // calculate (and subtract) whole days
    const days = Math.floor(delta / 86400);
    delta -= days * 86400;

    // calculate (and subtract) whole hours
    const hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    // calculate (and subtract) whole minutes
    const minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    // what's left is seconds
    const seconds = delta % 60;

    return {
      days,
      hours
    };
  }

  private syncServerClock(order: Order): void {
    if (!order.server_time) {
      return;
    }

    const serverTimestamp = new Date(order.server_time).getTime();
    if (!Number.isNaN(serverTimestamp)) {
      this._serverClockOffsetMs = serverTimestamp - Date.now();
    }
  }

  private getCurrentServerDate(): Date {
    return new Date(Date.now() + this._serverClockOffsetMs);
  }

  private attachRemainingDate(order: Order): void {
    const currentDate = this.getCurrentServerDate();
    const confirmationDeadline = order.confirmation_deadline_at
      ? new Date(order.confirmation_deadline_at)
      : new Date(new Date(order.created_at).getTime() + (72 * 60 * 60 * 1000));

    if (confirmationDeadline.getTime() > currentDate.getTime()) {
      order.timeToConfirm = this.compareTwoDates(currentDate, confirmationDeadline);
    }
    else {
      order.timeToConfirm = {
        hours: 0,
        days: 0
      };
    }

    if (order.state !== 'confirmed' || !order.confirmed_at) {
      order.timeToFulfillment = undefined;
      return;
    }

    const confirmedAt = new Date(order.confirmed_at);
    const fulfillmentDeadline = order.fulfillment_deadline_at
      ? new Date(order.fulfillment_deadline_at)
      : new Date(
          confirmedAt.getTime() + (this._fulfillmentDeadlineDays * 24 * 60 * 60 * 1000)
        );

    if (fulfillmentDeadline.getTime() > currentDate.getTime()) {
      order.timeToFulfillment = this.compareTwoDates(currentDate, fulfillmentDeadline);
    }
    else {
      order.timeToFulfillment = {
        hours: 0,
        days: 0
      };
    }
  }

  private loadOrdersForPartner(): void {
    this.ordersService.search(this.numberPerPageValue, this.page, this.status, '', this._dateSort, this._filter).subscribe((orders) => {
      // orders = this.hideTelephones(orders);
      console.log('orders', orders);
      orders = this.fixPaymentValues(orders);
      if (orders.data.length) {
        this.syncServerClock(orders.data[0]);
      }
      orders.data.forEach(order => {
        if (order.orderReturn?.state === 'waiting') {
          this.existOrderReturnWaitingState = true;
        }
        this.attachRemainingDate(order);
      });
      this.ordersDataSource = orders;
      console.log('this.ordersDataSource', this.ordersDataSource);
      this._maxPage = orders.meta.last_page;
      this.loadImagesForOrdersCollection(this.ordersDataSource);
    });
  }

  private loadSearchedOrdersForTable(): void {
    this.ordersService.search(
      this.numberPerPageValue,
      this.page,
      this.status,
      this._searchString,
      this._dateSort,
      this._filter
    ).subscribe(orders => {
     // orders = this.hideTelephones(orders);
      orders = this.fixPaymentValues(orders);
      if (orders.data.length) {
        this.syncServerClock(orders.data[0]);
      }
      orders.data.forEach(order => {
        this.attachRemainingDate(order);
      });
      this.ordersDataSource = orders;
      this._maxPage = orders.meta.last_page;
      this.loadImagesForOrdersCollection(this.ordersDataSource);
    });
  }

  // public convertMoneySum(sum: string): string {
  //   const convertedSum = Number.parseFloat(sum).toFixed(2);
  //   return convertedSum + ' €';
  // }

  public getCancellationFee(order: Order): string {
    const fees = order?.organisation_fees || [];
    const total = fees
      .filter(fee => fee.type === Fees.ORDER_CANCELATION_TYPE_FEE)
      .reduce((sum, fee) => sum + (Number.parseFloat(fee.gross_fee_amount) || 0), 0);

    return total > 0 ? this.formatPrice(total) : '-';
  }

  public getRefundFee(order: Order): string {
    if (!order || !order.organisation_fees.length) {
      return '-';
    }

    const fee = order.organisation_fees.find(
      feeTmp => feeTmp.type === Fees.ORDER_REFUND_TYPE_FEE
    )?.gross_fee_amount;

    return fee ? this.formatPrice(fee) : '-';
  }

  public getShareMeFee(order: Order): string {
    if (!order || !order.organisation_fees.length) {
      return '-';
    }

    const fee = order.organisation_fees.find(
      feeTmp => feeTmp.type === Fees.ORDER_DELIVERY_TYPE_FEE
    )?.gross_fee_amount;

    return fee ? this.formatPrice(fee) : '-';
  }

  public formatDeduction(value: string | number): string {
    if (value === '-' || value === null || value === undefined) {
      return '-';
    }

    const amount = Number.parseFloat(String(value));
    if (Number.isNaN(amount) || amount === 0) {
      return amount === 0 ? this.formatPrice(0) : '-';
    }

    return this.formatPrice(-Math.abs(amount));
  }

  public getRevertCommissionNet(order: Order): string {
    const fees = order?.organisation_fees || [];
    const revertedCommission = Math.abs(
      fees
        .filter(fee => fee.type === Fees.ORDER_DELIVERY_REVERT_TYPE_FEE)
        .reduce((sum, fee) => sum + (Number.parseFloat(fee.gross_fee_amount) || 0), 0)
    );
    const refundFee = fees
      .filter(fee => fee.type === Fees.ORDER_REFUND_TYPE_FEE)
      .reduce((sum, fee) => sum + (Number.parseFloat(fee.gross_fee_amount) || 0), 0);

    if (revertedCommission === 0 && refundFee === 0) {
      return '-';
    }

    return this.formatPrice(revertedCommission - refundFee);
  }

  public validateParcels(numberOfParcels: number, event: any): void {
    numberOfParcels = Number.parseInt(numberOfParcels.toString(), 10) || 0;
    if (numberOfParcels < 1) {
      this.numberOfParcels = 1;
      event.preventDefault();
      event.stopPropagation();
    }
    this.numberOfParcels = numberOfParcels;
    event.target.value = this.numberOfParcels = 1;
  }

  public setSearchedText(event): void {
    if (!event.target.value.length ) {
      this.clearSearchString();
    }
    else {
      this._searchString = event.target.value;
      if (this._searchString.length < 3) {
        this.loadOrdersForPartner();
        return;
      }
      this.search();
    }
  }

  public getDate(order: Order): {date: string, time: string} {
    if (this._tab === 'returned') {
      return this.convertDate(order.orderReturn.created_at);
    }
    return this.convertDate(order.created_at);

  }

  public getEndDate(order: Order): {date: string, time: string} {
    if (this._tab === 'returned') {
      const newDate = this.addDays(new Date(order.orderReturn.created_at), 14);
      return this.convertDate(newDate);
    }
  }

  public addDays(date: Date, days: number): string {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result.toString();
  }

  public shouldShowPickUpBtn(order: Order): number {
    return this.loggedPartner.data.organisations[0] &&
      this.loggedPartner.data.organisations[0].carrier_accounts.data[0]?.settings.dispatch_parcel_from === DispatchTypes.organisation &&
      order.shipment &&
      order.shipment[0].number_of_parcels;
  }

  public classEndTab(tabStatus: string): 'nav-link active' | 'nav-link' {
    return this._tab === tabStatus ?  'nav-link active' : 'nav-link';
  }

  public classTab(tabStatus: string): 'nav-link no-radius-tab active' | 'nav-link no-radius-tab' {
    return this._tab === tabStatus ?  'nav-link no-radius-tab active' : 'nav-link no-radius-tab';
  }

  public shareMeReturn(order: Order): number {
    return Number.parseFloat(((order.total_gross) ? order.total_gross * environment.ShareMeReturnTax : 0).toFixed(2));
  }

  public totalTaxReturn(order: Order): string {
    const cancellationFee = this.getCancellationFee(order) === '-' ? 0 : Number.parseFloat(this.getCancellationFee(order));
    const refundFee = this.getRefundFee(order) === '-' ? 0 : Number.parseFloat(this.getRefundFee(order));
    const wholeFee = cancellationFee + refundFee;
    return wholeFee.toFixed(2);

  }

  public paymentType(order: Order): 'С карта' | 'Наложен платеж' {
    if (order.paymentMethod.code === 'card') {
      return 'С карта';
    }
    return 'Наложен платеж';
  }

  public hideLastTelephoneDigits(telephone: string, numberOfHiddenDiits: number): string {
    return Core.replaceLastCharactersOfString(telephone, '*', numberOfHiddenDiits);

  }

  public deliveryAddress(order: Order): string {
    return order.delivery_address?.county + ', ' + order.delivery_address?.city + ', ' + order.delivery_address?.address_line_1;
  }

  public deliveryMethod(order: Order): string {
    return ShippingMethod[this._language][order.delivery_method];
  }

  public getShipmentStatus(order: Order): string {
    const effectiveStatus = this.getEffectiveShipmentStatus(order);
    if (effectiveStatus) {
      return ShipmentStatus[effectiveStatus] || effectiveStatus;
    }

    const shipment = order?.shipment?.[0];
    if (!shipment) {
      return '-';
    }

    const status = shipment.current_carrier_status || shipment.state;
    return ShipmentStatus[status] || shipment.last_track_and_trace_carrier_code_note || status || '-';
  }

  private getEffectiveShipmentStatus(order: Order): string | null {
    if (!order || !['dispatched', 'delivered'].includes(order.state)) {
      return null;
    }

    const shipment = order.shipment?.[0];
    if (!shipment) {
      return order.state === 'delivered' ? 'delivered' : null;
    }

    const status = shipment.current_carrier_status || shipment.state;
    const meaningfulShipmentStatuses = ['in_transit', 'out_for_delivery', 'delivered', 'undelivered', 'returned'];

    if (meaningfulShipmentStatuses.includes(status)) {
      return status;
    }

    return order.state === 'delivered' ? 'delivered' : null;
  }

  public get isDeliveredTab(): boolean {
    return this._tab === 'delivered';
  }

  public convertDate(date: string): {date: string, time: string} {
    return Convertor.convertDate.convertDateTimeWithDelimiter(date, '/');
  }

  public announceSortChange(sortState: Sort): void {
    if (sortState.active === 'Date' && sortState.direction === 'asc') {
      this._dateSort = 'created_at';
    } else if (sortState.active === 'Date' && sortState.direction === 'desc') {
      this._dateSort = '-created_at';
    } else if (sortState.active === 'RequestDate' && sortState.direction === 'asc') {
      this._dateSort = 'return_created_at';
    } else if (sortState.active === 'RequestDate' && sortState.direction === 'desc') {
      this._dateSort = '-return_created_at';
    }
    this.page = 1;
    this.getOrders();
  }

  public onTableScroll(e): void {
    const tableViewHeight = e.target.offsetHeight; // viewport: ~500px
    const tableScrollHeight = e.target.scrollHeight; // length of all table
    const scrollLocation = e.target.scrollTop; // how far user scrolled

    // If the user has scrolled within 200px of the bottom, add more data
    const buffer = 200;
    const limit = tableScrollHeight - tableViewHeight - buffer;
    if (scrollLocation > limit && !this._scrolling && this.numberPerPageValue === -1 && this.page < this._maxPage) {
      this._scrolling = true;
      this.page++;
      this.getOrders();
    }
  }

  public chooseNumberPerPage(event: { value: any; }): void {
    const value = event.value;
    this.numberPerPageValue = value;
    this.localStorageService.setLocalStorageItem(Labels.ordersPerPage, value);
    this.page = 1;
    this.ordersDataSource = { data: []};
    if (this.numberPerPageValue === -1) {
      for (let i = 0; i < this._initialNumberOfLoadedPages; i++) {
        this.page++;
        this.getOrders();
      }
    }
    else {
      this.getOrders();
    }
  }


  public loadSpecificPage(pageNumber): void {
    if (pageNumber < 0 || pageNumber > this._maxPage) {
      return;
    }
    this.ordersDataSource = { data: []};
    this.page = pageNumber;
    this.getOrders();
  }


  public search(): void {
    this.ordersDataSource = { data: []};
    this.initialLoad();
  }

  public clearSearchString(): void {
    this._searchString = '';
    this.ordersDataSource = { data: []};
    this.initialLoad();
  }


  public changeStateFilter(status: string): void {
    this.localStorageService.setLocalStorageItem(environment.lsOrderTab, status);
    switch (status) {
      case 'waiting':
        this.displayedColumnsForOrdersTable = this.displayedColumnsForNewOrdersTable;
        break;
      case 'confirmed':
        this.displayedColumnsForOrdersTable = this.displayedColumnsForProcessingOrdersTable;
        break;
      case 'dispatched':
      case 'delivered':
        this.displayedColumnsForOrdersTable = this.displayedColumnsForCompletedOrdersTable;
        break;
      case 'cancelled':
        this.displayedColumnsForOrdersTable = this.displayedColumnsForCanceledOrdersTable;
        break;
      case 'returned':
        this.displayedColumnsForOrdersTable = this.displayedColumnsForReturnedOrdersTable;
        break;
      default:
        this.displayedColumnsForOrdersTable = this.displayedColumnsForAllOrdersTable;
        break;
    }
    console.log('status', status);
    this.page = 1;
    this.status = status;
    this._tab = status;
    if (status === 'returned') {
      this._dateSort = '-return_created_at';
      this.isReturnedTab = true;
      this.status = 'delivered';
      this._filter = [
        {
          filter: 'returned',
          value: true
        }
      ];
    } else if (status === 'dispatched' || status === 'delivered') {
      this._dateSort = '-created_at';
      this.isReturnedTab = false;
      this.status = 'all';
      this._filter = [
        {
          filter: 'partner_status',
          value: status === 'dispatched' ? 'fulfilled' : 'delivered'
        }
      ];
    } else {
      this._dateSort = '-created_at';
      this.isReturnedTab = false;
      this._filter = [];
    }
    this.initialLoad();
    setTimeout(
      () => this.loadTooltips(),
      1000
    );
  }


  public goToPreviousPage(): void {
    if (this.page === 1) {
      return;
    }
    this.page--;
    this.ordersDataSource = { data: []};
    this.getOrders();
  }

  public goToNextPage(): void {
    if (this.page === this._maxPage) {
      return;
    }
    this.page++;
    this.ordersDataSource = { data: []};
    this.getOrders();

  }

  public resetPage(): void {
    this.page = 1;
    this.getOrders();
  }

  public convertPrice(price: number | string, removeZero?: boolean): string {
    return this.formatPrice(price, { removeZero });
  }

  public convertMoneySum(sum: string): string {
    return this.formatPrice(sum);
  }


  // public convertOrderStatus(order: Order, orderStatus: string): any {
  //   console.log('convertOrderStatus order--->', order);
  //   console.log('convertOrderStatus orderStatus--->', orderStatus);
  //   if (this._tab === 'confirmed') {
  //     if (this.isRequested(order)) {
  //       return OrderStatus.requested;
  //     }
  //     if (this.isPrinted(order)) {
  //       return OrderStatus.printed;
  //     }
  //   }
  //   if (this._tab === 'returned') {
  //    if (this.isReturned(order)) {
  //      if (order.orderReturn.state === 'confirmed'){
  //        return OrderStatus.returnedConfirmed;
  //      }else if (order.orderReturn.state === 'canceled'){
  //        return OrderStatus.returnedCanceled;
  //      }else if (order.orderReturn.state === 'waiting'){
  //        return OrderStatus.returnedWaiting;
  //      }
  //    }
  //   }
  //   return OrderStatus[orderStatus];
  // }

  public convertOrderStatus(order: Order, orderStatus: string): any {
    const isConfirmedTab = this._tab === 'confirmed';
    const isReturnedTab = this._tab === 'returned';

    if (isConfirmedTab && this.isRequested(order)) { return OrderStatus.requested; }
    if (isConfirmedTab && this.isPrinted(order)) { return OrderStatus.printed; }

    if (isReturnedTab && this.isReturned(order)) {
      const returnMap: Record<string, string>  = {
        confirmed: OrderStatus.returnedConfirmed,
        cancelled: OrderStatus.returnedCancelled,
        waiting: OrderStatus.returnedWaiting
      };
      return returnMap[order.orderReturn?.state] || OrderStatus[orderStatus];
    }

    const shipmentStatus = this.getEffectiveShipmentStatus(order);
    return shipmentStatus ? ShipmentStatus[shipmentStatus] : OrderStatus[orderStatus];
  }

  public checkGroupType(isGroup: boolean | null): 'Лична' | 'Групова' {
    if (!isGroup) {
      return 'Лична';
    }
    return 'Групова';
  }

  public confirmOrder(order: Order, event): void {
    this.ordersService.confirmOrder(order.uuid, { number_of_parcels: 1}).subscribe(() => {
      this.toatsrService.success(Successes.confirmedOrder[this.language]);
      this.initialLoad();
    }, (error) => this.toatsrService.error(ErrorTranslations.translate(error.error.exception.message, this.language)));
    event.stopPropagation();
  }

  goToDetails(order: Order, event): void {
    this.router.navigate(['dashboard/order/' + order.uuid + '/' + this.page]);
  }

  cancel(order: Order): void {
    if (!this.canCancelOrder) {
      return;
    }

    this.ordersService.cancelOrder(order.uuid, {
      reason: this.cancellationReason,
      comment: this.isOtherCancellationReason ? this.cancellationComment.trim() : undefined
    }).subscribe(() => {
      this._currentOpenWindow.close();
      this.resetCancellationForm();
      this.getOrders();
      this.toatsrService.success(Successes.cancledOrder[this.language]);
    }, (error) => this.toatsrService.error(ErrorTranslations.translate(error.error.exception.message, this.language)));
  }

  pickup(order: Order, event: Event): void {
    event.stopPropagation();

    this.shipmentService.createShipment(order.shipment[0].uuid).subscribe(() => {
      this.toatsrService.success('Успешо заявяване от куриер');
      this.initialLoad();
    });
  }

  public shouldClientBeHidden(order: Order): boolean {
    if (['waiting', 'cancelled'].includes(order.state)) {
      return true;
    }
    return false;
  }

  public createShipmentGeneration(order: Order): void {
    this.selectedOrder = order;
    this.generateShipment();
  }

  public openModal(modal: any): void {
    this.modalService.open(modal, { centered: true } );
  }

  public openCancelOrderDialog(order: Order, event: { stopPropagation: () => void; }): void {
    this.resetCancellationForm();
    this.selectedOrder = order;
    this.router.navigate(['dashboard/order/' + order.uuid]);
    this._currentOpenWindow = this.modalService.open(this._cancelWindowmodal, { centered: true } );
    event.stopPropagation();
  }

  private resetCancellationForm(): void {
    this.cancellationReason = '';
    this.cancellationComment = '';
  }

  public openReturnOrderDialog(order: Order, event: { stopPropagation: () => void; }): void {
    console.log('openReturnOrderDialog order --->', order);
    this.selectedOrder = order;
    this.amountRequestedInput = this.calculateRequestRefund(order);
    this.formattedAmountRequestedInput = Number(this.calculateRequestRefund(order)).toFixed(2);
    this._currentOpenWindow = this.modalService.open(this._returnWindow, { centered: true } );
    event.stopPropagation();
  }

  public openCancelReturnDialog(order: Order, event: { stopPropagation: () => void; }): void {
    this.selectedOrder = order;
    this._currentOpenWindow = this.modalService.open(this._cancelReturnWindow, { centered: true } );
    event.stopPropagation();
  }

  public generateShipment(): void {
    this.shipmentService.updateParcels({ number_of_parcels: this.numberOfParcels}, this.selectedOrder.shipment[0].uuid).subscribe(() => {
      this.toatsrService.success('Успешно генерирана товарителница');
    });
  }

  public printWayBill(order: Order, event: any): void {
    event.stopPropagation();
    this.shipmentService.printWayBill(order.shipment[0].uuid).subscribe((response) => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(response);
      a.download = 'Waybill.pdf';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      this.toatsrService.success('Успешно генериран документ');
    });
  }

  public printStockReciept(order: Order, event: any): void {
    event.stopPropagation();
    this.ordersService.downloadOrderDocument(order.uuid).subscribe((response) => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(response);
      a.download = 'Stock.pdf';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      this.toatsrService.success('Успешно генериран документ');
    });
  }

  calculateRequestRefund(order: Order): number {
    if (!order.orderReturn || !Array.isArray(order.orderReturn.items)) {
      return 0;
    }

    const total = order.orderReturn?.items.reduce((sum, item) => {
      const quantity = Number(item.quantity);
      const price = parseFloat(item.order_line?.single_gross ?? '0');

      return sum + quantity * price;
    }, 0);

    return total.toFixed(2); // закръгляне до 2 знака
  }

  cancelReturn(order: Order): void {
    this.ordersService.cancelReturn(order.orderReturn?.uuid).subscribe(() => {
      this._currentOpenWindow.close();
      this.getOrders();
      this.refreshWaitingReturnIndicator();
      this.toatsrService.success('Успешо отказахте заявката за връщане');
    }, (res) => {
      console.log('error', res.error.message);
      this.toatsrService.error('Нещо се обърка. Моля опитайте по - късно.');
    });
  }

  confirmReturn(order: Order): void {
    if (Number(this.formattedAmountRequestedInput) > this.calculateRequestRefund(order)){
      this.toatsrService.warning('Не може да възстановите повече от сумата на върнатите продукти');
      return;
    }
    this._currentOpenWindow.close();
    this.ordersService.confirmReturn(order.orderReturn?.uuid, Number(this.formattedAmountRequestedInput)).subscribe(() => {
      this.getOrders();
      this.refreshWaitingReturnIndicator();
      this.toatsrService.success('Успешо одобрихте сумата за връщане');
    }, (res) => {
      console.log('error', res.error.message);
      this.toatsrService.error('Нещо се обърка. Моля опитайте по - късно.');
    });
  }

  onAmountInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    let rawValue = input.value;

    rawValue = rawValue.replace(/[^0-9.]/g, '');

    const dotIndex = rawValue.indexOf('.');
    if (dotIndex !== -1) {
      rawValue = rawValue.substring(0, dotIndex + 1) + rawValue.substring(dotIndex + 1).replace(/\./g, '');
    }

    this.formattedAmountRequestedInput = rawValue;
  }

  onAmountKeyDown(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'];
    const numberKeys = /^[0-9]$/;

    if (allowedKeys.includes(event.key)) {
      return;
    }

    const inputEl = event.target as HTMLInputElement;
    const inputValue = inputEl.value || '';
    const parts = inputValue.split('.');

    if (numberKeys.test(event.key)) {
      if (parts.length > 1 && parts[1].length >= 2) {
        const cursorStart = inputEl.selectionStart || 0;
        const cursorEnd = inputEl.selectionEnd || 0;
        const dotPosition = inputValue.indexOf('.');

        if (cursorStart > dotPosition && cursorStart === cursorEnd) {
          event.preventDefault();
          return;
        }
      }
      return;
    }

    if (event.key === '.') {
      if (inputValue.includes('.')) {
        event.preventDefault();
      }
      return;
    }

    event.preventDefault();
  }

  onAmountBlur(): void {
    let value = this.formattedAmountRequestedInput || '';

    value = value.replace(/[^0-9.]/g, '');

    const parts = value.split('.');

    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }

    if (parts.length > 1 && parts[1].length > 2) {
      parts[1] = parts[1].substring(0, 2);
      value = parts.join('.');
    }

    if (value === '' || value === '.') {
      value = '0';
    }

    let parsed = Number(value);

    if (isNaN(parsed)) {
      parsed = 0;
    }

    const maxAmount = Number(this.selectedOrder?.orderReturn?.amount_requested || 0);

    // if (parsed > maxAmount) {
    //   parsed = maxAmount;
    // }

    if (parsed < 0) {
      parsed = 0;
    }

    this.amountRequestedInput = parsed;
    this.formattedAmountRequestedInput = parsed.toFixed(2);
  }


  getOrderStatusColor(order: Order): any {
    if (this._tab === 'returned' && this.isReturned(order)) {
      const returnMap: Record<string, string>  = {
        confirmed: OrderStatusColors.returnedConfirmed,
        cancelled: OrderStatusColors.returnedCancelled,
        waiting: OrderStatusColors.waiting
      };
      return returnMap[order.orderReturn?.state];
    }

    const shipmentStatus = this.getEffectiveShipmentStatus(order);
    const shipmentStatusColors: Record<string, string> = {
      in_transit: OrderStatusColors.dispatched,
      out_for_delivery: OrderStatusColors.dispatched,
      delivered: OrderStatusColors.delivered,
      undelivered: OrderStatusColors.cancelled,
      returned: OrderStatusColors.returned
    };

    return shipmentStatus ? shipmentStatusColors[shipmentStatus] : OrderStatusColors[order.state];
  }

  public resetFilters(): void {
    this._filter = [];
    this.page = 1;
    this.status = 'confirmed';
    this._tab = this.status;
    this.getOrders();
  }

  public getConfimedOrders(): void {
    this._filter = [];
    this.page = 1;
    this.status = 'confirmed';
    this._tab = this.status;
    this.getOrders();
  }

  public getForPickupOrders(): void {
    this._filter = [
      {
        filter: 'shipment.state',
        value: 'request_pickup'
      }
    ];
    this.status = 'confirmed';
    this._tab = this.status;
    this.page = 1;
    this.getOrders();
  }

  public getForDelivery(): void {
    this._filter = [
      {
        filter: 'shipment.state',
        value: 'out_for_delivery'
      }
    ];
    this.status = 'confirmed';
    this._tab = this.status;
    this.page = 1;
    this.getOrders();
  }

  public getWaitingReturnedOrders(): void {
    this._filter = [
      {
        filter: 'orderReturn.state',
        value: 'waiting'
      }
    ];
    this.page = 1;
    this.status = 'delivered';
    this._tab = 'returned';
    this.getOrders();
  }

  public getConfirmedReturnedOrders(): void {
    this._filter = [
      {
        filter: 'orderReturn.state',
        value: 'confirmed'
      }
    ];
    this.page = 1;
    this.status = 'delivered';
    this._tab = 'returned';
    this.getOrders();
  }

  public getCancelledReturnedOrders(): void {
    this._filter = [
      {
        filter: 'orderReturn.state',
        value: 'cancelled'
      }
    ];
    this.page = 1;
    this.status = 'delivered';
    this._tab = 'returned';
    this.getOrders();
  }

  public getAllReturnedOrders(): void{
    this._filter = [
      {
        filter: 'returned',
        value: true
      }
    ];
    this.page = 1;
    this.status = 'delivered';
    this._tab = 'returned';
    this.getOrders();
  }
}
